// $(document).on("click", ".link_to_page", (e) => {
// 	let el = e.currentTarget;

// 	let title = $(el).data("title")
// 	let is_public = $(el).data("is_public")
// 	let is_link = $(el).data("is_link")

// 	if(is_link) {
// 		frappe.set_route("List", title)
// 		return;
// 	}

// 	let url = "/app/" 
// 	url += is_public ? frappe.router.slug(title): "private/" + frappe.router.slug(title)

// 	frappe.set_route(url)
// })
$(document).on("click", ".link_to_page", function (e) {

    if (e.ctrlKey || e.metaKey || e.which === 2) {
        return;
    }

    e.preventDefault();

    $(".link_to_page.active").removeClass("active");
    $(this).addClass("active");

    const route_name =
        $(this).data("route");

    const title =
        $(this).data("title");

    const is_public =
        String($(this).data("is_public")) === "1";

    const is_link =
        String($(this).data("is_link")) === "1";

    const route =
        route_name || title;

    let url =
        "/app/" +
        frappe.router.slug(route);

    if (!is_public) {

        url =
            "/app/private/" +
            frappe.router.slug(route);
    }

    $(this).attr("href", url);

    if (is_link) {

        frappe.set_route(
            "List",
            route
        );

    } else {

        frappe.set_route(url);
    }
});


$(document).on("click", function (event) {
    $(".side-menu").first().removeClass("side-menu--mobile-menu-open");
    $(".close-mobile-menu").first().removeClass("close-mobile-menu--mobile-menu-open");
});

$(document).on("click", ".side-menu a", function () {
    $(".side-menu").removeClass("side-menu--mobile-menu-open");
    $(".close-mobile-menu").removeClass("close-mobile-menu--mobile-menu-open");
});

// Safely attach router change handler only if frappe.router exists
if (frappe.router && typeof frappe.router.on === 'function') {
    frappe.router.on('change', () => {
        $(".side-menu").removeClass("side-menu--mobile-menu-open");
        $(".close-mobile-menu").removeClass("close-mobile-menu--mobile-menu-open");
    });
}

//sidebar hide logic 
function apply_global_sidebar_control() {
    const is_enabled = localStorage.getItem("sidebar_content");

    const el = document.querySelector(".toggle-compact-menu");

    if (!el) return;

    if (is_enabled === "1") {
        localStorage.setItem("compactMenu", "false");
        localStorage.setItem("forceCompactMenuFalse", "true");

        el.classList.add("force-hide");
    } else {
        el.classList.remove("force-hide");
        localStorage.removeItem("forceCompactMenuFalse");
    }
}

// Safely call apply_global_sidebar_control after AJAX requests
if (frappe.after_ajax && typeof frappe.after_ajax === 'function') {
    frappe.after_ajax(() => {
        apply_global_sidebar_control();
    });
} else if (frappe.call && typeof frappe.call === 'function') {
    // Fallback: Use frappe.call's global ajax complete handler
    $(document).ajaxComplete(() => {
        apply_global_sidebar_control();
    });
} else {
    // Final fallback: Just call it after a short delay
    setTimeout(apply_global_sidebar_control, 100);
}

// Safely attach router change handler
if (frappe.router && typeof frappe.router.on === 'function') {
    frappe.router.on("change", () => {
        setTimeout(apply_global_sidebar_control, 300);
    });
}

document.addEventListener("DOMContentLoaded", () => {
    setTimeout(apply_global_sidebar_control, 500);
});
window.apply_global_sidebar_control = function () {
    const is_enabled = localStorage.getItem("sidebar_content");

    const el = document.querySelector(".toggle-compact-menu");

    if (!el) return;

    if (is_enabled === "1") {
        el.classList.add("force-hide");
    } else {
        el.classList.remove("force-hide");
    }
};

//sidebar expand logic open and close

document.addEventListener("DOMContentLoaded", function () {
    const fullscreenBtn = document.querySelector(".request-full-screen");
    if (fullscreenBtn) {
        fullscreenBtn.addEventListener("click", async function () {
            try {
                if (!document.fullscreenElement) {
                    if (document.documentElement.requestFullscreen) {
                        await document.documentElement.requestFullscreen();
                    } else if (document.documentElement.webkitRequestFullscreen) {
                        await document.documentElement.webkitRequestFullscreen();
                    } else if (document.documentElement.msRequestFullscreen) {
                        await document.documentElement.msRequestFullscreen();
                    }
                } else {
                    if (document.exitFullscreen) {
                        await document.exitFullscreen();
                    } else if (document.webkitExitFullscreen) {
                        await document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) {
                        await document.msExitFullscreen();
                    }
                }
            } catch (error) {
                console.warn("Fullscreen API failed:", error.message);
            }
        });
    }
    const headerSelector = '.fixed.top-0.inset-x-0';
    function updateHeader() {
        const header = document.querySelector(headerSelector);
        const sidebar =
            document.querySelector('.form-sidebar.overlay-sidebar') ||
            document.querySelector('.list-sidebar.overlay-sidebar');
        if (!header || !sidebar) return;
        const isOpen = sidebar.classList.contains('opened');
        if (isOpen) {
            header.style.display = 'none';
        } else {
            header.style.display = 'flex';
        }
    }
    updateHeader();
    const observer = new MutationObserver(updateHeader);
    observer.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true
    });
    window.addEventListener("resize", updateHeader);
    document.addEventListener("click", () => {
        setTimeout(updateHeader, 100);
    });
});

if (window.location.pathname.includes("/login")) {
} else {
    // Toggle icon logic
    function updateIcon() {
        document.querySelectorAll('use[href="#es-line-align-justify"]').forEach((el) => {
            el.setAttribute("href", "#es-line-align");
        });
    }
    window.addEventListener("load", () => {
        updateIcon();
        const observer = new MutationObserver(() => {
            updateIcon();
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });

    frappe.router.on("change", () => {
        setTimeout(() => {
            const frm = cur_frm;

            if (!frm || !frm.page || !frm.page.sidebar) return;

            const sidebar = frm.page.sidebar.$sidebar?.[0];
            if (!sidebar) return;

            if (sidebar.querySelector(".custom-grid")) return;

            const assignments = sidebar.querySelector(".form-assignments");
            const attachments = sidebar.querySelector(".form-attachments");
            const tags = sidebar.querySelector(".form-tags");
            const share = sidebar.querySelector(".form-shared");

            if (!assignments || !attachments || !tags || !share) return;

            const grid = document.createElement("div");
            grid.className = "custom-grid";

            function card(title, icon, source) {
                const div = document.createElement("div");
                div.className = "custom-card";

                div.innerHTML = `
                    <svg class="es-icon">
                        <use href="${icon}"></use>
                    </svg>
                    <span>${title}</span>
                `;

                div.onclick = () => {
                    source.querySelector("button,a")?.click();
                };

                return div;
            }

            grid.appendChild(card("Assigned To", "#es-line-add", assignments));
            grid.appendChild(card("Attachments", "#es-line-attachment", attachments));
            grid.appendChild(card("Tags", "#es-line-tag", tags));
            grid.appendChild(card("Share", "#es-line-share", share));
            attachments.before(grid);
            assignments.style.display = "none";
            attachments.style.display = "none";
            tags.style.display = "none";
            share.style.display = "none";
        }, 300);
    });
frappe.provide("custom.sidebar");

custom.sidebar.update = function () {

    let sidebar = document.querySelector(".form-sidebar");
    if (!sidebar) return;

    // ---------------- People ----------------
    let people = sidebar.querySelector(".add-assignment-label");
    if (people) {
        people.innerHTML = `
            <span style="font-size:16px; margin-right:6px;">👥</span>
            <span class="ellipsis">People</span>
        `;
    }

    // ---------------- Files ----------------
    let files = sidebar.querySelector(".form-attachments .form-sidebar-items > span");
    if (files) {
        files.innerHTML = `
            <span style="font-size:16px; margin-right:6px;">📁</span>
            <a class="pill-label ellipsis explore-link">Files</a>
        `;
    }

    // ---------------- Labels ----------------
    let labels = sidebar.querySelector(".form-tags .form-sidebar-items > span");
    if (labels) {
        labels.innerHTML = `
            <span style="font-size:16px; margin-right:6px;">🏷️</span>
            <span class="tags-label ellipsis">Labels</span>
        `;
    }

    // ---------------- Send ----------------
    let send = sidebar.querySelector(".share-label");
    if (send) {
        send.innerHTML = `
            <span style="font-size:16px; margin-right:6px;">↗️</span>
            <span class="ellipsis">Send</span>
        `;
    }
};

// Run after route change
frappe.router.on("change", () => {
    setTimeout(() => {
        custom.sidebar.update();
    }, 1000);
});

// Run after form refresh
$(document).on("form-refresh", function () {
    setTimeout(() => {
        custom.sidebar.update();
    }, 500);
});

}
$(document).on("click", ".link_to_page", function (e) {

    if (e.ctrlKey || e.metaKey || e.which === 2) {
        return;
    }

    e.preventDefault();

    $(".link_to_page.active").removeClass("active");
    $(this).addClass("active");

    const route_name =
        $(this).data("route");

    const title =
        $(this).data("title");

    const is_public =
        String($(this).data("is_public")) === "1";

    const is_link =
        String($(this).data("is_link")) === "1";

    const route =
        route_name || title;

    let url =
        "/app/" +
        frappe.router.slug(route);

    if (!is_public) {

        url =
            "/app/private/" +
            frappe.router.slug(route);
    }

    $(this).attr("href", url);

    if (is_link) {

        frappe.set_route(
            "List",
            route
        );

    } else {

        frappe.set_route(url);
    }
});


// $(document).on(
//     "click",
//     ".workspace_group",
//     function (e) {

//         e.preventDefault();

//         $(this)
//             .next(".workspace_children")
//             .slideToggle(200);

//         $(this)
//             .find(".side-menu__link__chevron")
//             .toggleClass("rotate-180");
//     }
// );